import {
  Card,
  Text,
  Group,
  Container,
  Title,
  ActionIcon,
} from "@mantine/core";
import {
  IconMail,
  IconBrandInstagram,
  IconBrandLinkedin,
} from "@tabler/icons-react";
import { Element } from "react-scroll";

export default function Contact() {
  return (
    <Element name="contact">
      <Container size="sm" mt={50} py={50}>
        <Card shadow="sm" padding="lg" radius="md" mt="sm" withBorder>
          <Card.Section pt="sm">
            <Title style={{ textAlign: "center" }}>Contact</Title>
          </Card.Section>

          <Group mt="md" mb="xs">
            <ActionIcon size="lg" color="gray" variant="subtle">
              <IconMail size={18} stroke={1.5} />
            </ActionIcon>
            <Text fw={500}>alvian.ardhiansyah@gmail.com</Text>
          </Group>

          <Group
            style={{ textDecoration: "none" }}
            component="a"
            href="https://instagram.com/alvianardhn_"
            target="_blank"
            mt="md"
            mb="xs"
          >
            <ActionIcon size="lg" color="gray" variant="subtle">
              <IconBrandInstagram size={18} stroke={1.5} />
            </ActionIcon>
            <Text fw={500}>@alvianardhn_</Text>
          </Group>

          <Group
            style={{ textDecoration: "none" }}
            component="a"
            href="https://www.linkedin.com/in/alvian-ardhiansyah"
            target="_blank"
            mt="md"
            mb="xs"
          >
            <ActionIcon size="lg" color="gray" variant="subtle">
              <IconBrandLinkedin size={18} stroke={1.5} />
            </ActionIcon>
            <Text fw={500}>linkedin.com/in/alvian-ardhiansyah</Text>
          </Group>
        </Card>
      </Container>
    </Element>
  );
}
